import * as THREE from "three"
import { CSS3DObject } from "three/examples/jsm/renderers/CSS3DRenderer.js"

import Experience from "../Experience";

export default class Screen {

    constructor(iframe) {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.iframe = iframe

        // Setup CSS3DObject
        this.screenObject = new CSS3DObject(this.iframe)
        this.screenObject.position.set(0, 0, 0)

        this.handleZoomChange = ({ detail }) => {
            this.setInteractivity(detail?.isZoomedIn === true)
        }

        this.setInteractivity(this.experience.camera?.isZoomedIn === true)
        window.addEventListener("camera-zoom-change", this.handleZoomChange)
    }

    setInteractivity(isInteractive) {
        this.iframe.style.pointerEvents = isInteractive ? "auto" : "none"
    }

    setModel(mesh) {
        this.screenObject.position.set(0, 3.15, -1)
        this.screenObject.rotation.set(0, Math.PI, 0)

        // Scale to fit
        // Adjusted scale for 800px iframe
        this.screenObject.scale.set(0.00956, 0.00956, 0.00956)

        mesh.add(this.screenObject)
        this.iframe.style.visibility = "visible"
    }

    update() {


    }
}
